import React, {useState, useEffect} from "react";
import QuadralList from '@quadral/quadral-component-common/dist/components/list';
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import { purchaseOrdersService } from "../../services";

const PurchaseOrderList = (props) => {
    let sortParams = {};

    const {statusParam, showLoader, hideLoader, setSearchFormData, searchFormData, setTotalRecords, setPurchaseOrders} = props;
    const [sorting, setSorting] = useState(searchFormData?.sort);

    function getDiagnosticianName(item) {
        return item.diagnostician?.name;
    }

    function computeProgressionValue(item) {
        return item.validDiagnosticsCount && item.diagnosticsCount ?
            Math.round((item.validDiagnosticsCount / item.diagnosticsCount) * 100) : 0;
    }

    function getReferencesText(item) {
        const orderNumber = item.orderNumber || "";
        const customerReference = item.customerReference || "";
        return orderNumber + (orderNumber && customerReference ? " / " : "") + customerReference;
    }

    const columns = [
        {
            id: 'references',
            label: 'Ref Quadral / Ref client',
            render: (row) => getReferencesText(row)
        },
        {
            id: 'diagnostician',
            label: 'Diagnostiqueur',
            render: (row) => getDiagnosticianName(row)
        },
        {
            id: 'status',
            label: 'Statut',
            render: (row) => row?.status
        },
        {
            id: 'diagnosticsCount',
            label: 'Diagnostics',
            render: (row) => `${computeProgressionValue(row)}%`
        },
        {
            id: 'effectiveDate',
            label: 'Date de commande',
            render: (row) => row?.effectiveDate
        },
        {
            id: 'lastVisitDate',
            label: 'Date de passage',
            render: (row) => row?.lastVisitDate
        },
        {
            id: 'closingDate',
            label: 'Date de clôture',
            render: (row) => row?.closingDate
        },
    ];

    useEffect(() => {
        if (!sorting) {
            return;
        }

        if (!statusParam) {
            showLoader();
            setSearchFormData(Object.assign(searchFormData, {
                sort: sorting
            }))

            let filteredCriterias = purchaseOrdersService.removeEmptyValue(searchFormData);

            purchaseOrdersService.searchPurchaseOrders(filteredCriterias)
                .then(searchResults => {
                    setTotalRecords(searchResults.totalRecords)
                    setPurchaseOrders(searchResults)
                    hideLoader();
                })
                .catch(err => {
                    console.error("Error while sorting: " + err);
                    hideLoader();
                });
        }
    }, [sorting, statusParam, showLoader, hideLoader, setSearchFormData, searchFormData, setTotalRecords, setPurchaseOrders]);

    const render = () => (
        <>
            {props.totalRecords && props.totalRecords > 0 ?
                <span className="result">{props.totalRecords} résultat{props.totalRecords > 1 ? 's' : ''}</span> :
                <span className="result">Aucun résultat</span>
            }
            <QuadralList
                columns={columns}
                rows={(props.purchaseOrders?.purchaseOrders || []).map(purchaseOrder => ({
                    ...purchaseOrder,
                    link: `/bon-de-commande?id=${purchaseOrder.id}`
                }))}
                sortable={true}
                sortMethod={setSorting}
                missionsParams={sortParams}
                selectable={false}
            />
            {props.purchaseOrders && props.purchaseOrders.purchaseOrders && props.purchaseOrders.hasMoreResults && (
                <QuadralButton onClick={props.nextPageFn}>Afficher plus de résultats</QuadralButton>
            )}
        </>
    );

    return render();
}

export default PurchaseOrderList;